export default "__VITE_ASSET__BjjpTVjw__"